import {searchResources} from "./modules/searchResources";

document.addEventListener('DOMContentLoaded', () => {
  searchResources(Array.prototype.slice.call(document.querySelectorAll('.js-search-resources-embed-tweet'), 0));
});
